import React from 'react';

const AboutCEP = () => {
  return (
    <div className="page-container">
      <h1>About CEP... Comming Soon..</h1>
      {/* <p>This is the About CEP page content.</p> */}
    </div>
  );
};

export default AboutCEP;
